/**
 * MainWindowHeader.js
 * Talkroute
 *
 * Created by Vel Genov on 2/4/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

import React from "react";
import { Switch, Route } from "react-router-dom";
import { isIOS } from "@constants/appConstants";

import routes from "../constants/routes";
import KeypadHeader from "../components/keypadComponents/KeypadHeader";
import CallHistoryFilter from "../components/CallHistory/CallHistoryFilter";
import ConversationFilter from "../components/conversationComponents/ConversationFilter";
import VoicemailFilter from "../components/voicemailComponents/VoicemailFilter";
import ColumnHeader from "../components/Meetings/ColumnHeader";

/**
 * The header for the main window. Currently contains filters for the different elements
 */
class MainWindowHeader extends React.Component {
  render() {
    let WebkitAppRegion = "inherit";
    if (isIOS) WebkitAppRegion = "drag";

    return (
      <div
        style={
          {
            height: "60px",
            minHeight: "60px",
            borderBottom: "1px solid var(--color-dark-grey)",
            zIndex: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: "1em",
            WebkitAppRegion,
          } as any
        }
      >
        <Switch>
          <Route path={routes.KEYPAD} component={KeypadHeader} />
          <Route path={routes.CALL_HISTORY} component={CallHistoryFilter} />
          <Route path={routes.TEXT_MESSAGES} component={ConversationFilter} />
          <Route path={routes.VOICEMAIL} component={VoicemailFilter} />
          <Route path={routes.MEETINGS} component={ColumnHeader} />
        </Switch>
      </div>
    );
  }
}

export default MainWindowHeader;
